var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram logo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1537_339791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 7",
    filter: "url(#filter0_b_1537_339791)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4,
    height: 32.1,
    fill: "#444444",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0014 11.3078C12.9583 11.3078 11.3103 12.9562 11.3103 14.9998C11.3103 17.0434 12.9583 18.6918 15.0014 18.6918C17.0446 18.6918 18.6926 17.0434 18.6926 14.9998C18.6926 12.9562 17.0446 11.3078 15.0014 11.3078ZM15.0014 17.4001C13.6811 17.4001 12.6017 16.3236 12.6017 14.9998C12.6017 13.676 13.6779 12.5995 15.0014 12.5995C16.325 12.5995 17.4011 13.676 17.4011 14.9998C17.4011 16.3236 16.3217 17.4001 15.0014 17.4001ZM19.7045 11.1568C19.7045 11.6356 19.319 12.0179 18.8436 12.0179C18.3649 12.0179 17.9826 11.6324 17.9826 11.1568C17.9826 10.6813 18.3681 10.2957 18.8436 10.2957C19.319 10.2957 19.7045 10.6813 19.7045 11.1568ZM22.1492 12.0308C22.0946 10.8773 21.8312 9.85546 20.9863 9.01359C20.1446 8.17173 19.123 7.90825 17.9698 7.85041C16.7811 7.78294 13.2185 7.78294 12.0299 7.85041C10.8798 7.90504 9.85821 8.16852 9.01332 9.01038C8.16844 9.85224 7.90823 10.874 7.8504 12.0276C7.78294 13.2165 7.78294 16.7799 7.8504 17.9688C7.90501 19.1224 8.16844 20.1442 9.01332 20.986C9.85821 21.8279 10.8766 22.0914 12.0299 22.1492C13.2185 22.2167 16.7811 22.2167 17.9698 22.1492C19.123 22.0946 20.1446 21.8311 20.9863 20.986C21.828 20.1442 22.0914 19.1224 22.1492 17.9688C22.2167 16.7799 22.2167 13.2197 22.1492 12.0308ZM20.6136 19.2445C20.3631 19.8742 19.878 20.3594 19.2451 20.6133C18.2974 20.9892 16.0487 20.9025 15.0014 20.9025C13.9541 20.9025 11.7022 20.986 10.7577 20.6133C10.1281 20.3627 9.64297 19.8775 9.38919 19.2445C9.01332 18.2966 9.10006 16.0473 9.10006 14.9998C9.10006 13.9523 9.01654 11.6998 9.38919 10.7552C9.63976 10.1254 10.1248 9.64017 10.7577 9.38633C11.7054 9.01038 13.9541 9.09714 15.0014 9.09714C16.0487 9.09714 18.3006 9.01359 19.2451 9.38633C19.8748 9.63696 20.3598 10.1222 20.6136 10.7552C20.9895 11.7031 20.9028 13.9523 20.9028 14.9998C20.9028 16.0473 20.9895 18.2998 20.6136 19.2445Z",
    fill: "#F2F2F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1537_339791",
    x: -1.2,
    y: -1.2,
    width: 34.7999,
    height: 34.5001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1537_339791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1537_339791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1537_339791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.74fdfe2795dffdad85d1698617990023.svg";
export { ForwardRef as ReactComponent };